<!--
 * @Author: 陈远锋
 * @Date: 2022-03-05 08:52:40
 * @LastEditTime: 2022-03-09 11:30:56
 * @FilePath: \qyOut\src\pages\supplier\edit.vue
 * @Description: Do not edit
-->
<template>
    <div>
        <Breadcrumb :style="{ margin: '20px 10px' }">
            <BreadcrumbItem>代理商商品管理</BreadcrumbItem>
            <BreadcrumbItem>编辑入库单</BreadcrumbItem>
        </Breadcrumb>
        <loading :loading="loading" :error="error"></loading>
        <formPage :distribute="distribute" :companies="companies" :checkObjName="checkObjName" v-on:handleSubmit="handleSubmit"></formPage>
    </div>
</template>
<script>
import formPage from './form.vue';
import loading from '../loading.vue';
import axios from "axios";
export default {
    components: { formPage, loading },
    data () {
        return {
            distribute: {},
            loading: false,
            companies: [],
            checkObjName: '',
            error: null,
        }
    },
    created () {
        console.log("edit")
        this.fetchData()
        axios.get("company?type=0").then(res => {
          this.companies = res.data.companies
        })
        console.log(this.$route.params)
    },
    watch: {
        $route (to, from) {
            // 对路由变化作出响应...
            console.log("to", to)
            console.log("from", from)
        }
    },
    methods: {
        handleSubmit (purchase) {
            // 验证通过
            console.log("验证通过", purchase);
            this.loading = true; this.error = null
            this.axios
                .post("agentGoodsDistribute/edit/" + purchase.id, purchase)
                .then((res) => {
                    console.log("修改返回res", res)
                    this.loading = false;
                    if (res.data.status === 200) {
                        this.$Message.success('修改成功');
                        setTimeout(() => {
                            this.$router.push("/pages/agent_goods_distribute_list");
                        }, 2000);
                    } else {
                      this.$Message.error(res.data.msg);
                    }
                })
        },

        fetchData () {
            this.error = null;
            this.loading = true;
            this.axios
                .get("agentGoodsDistribute/show/" + this.$route.params.id)
                .then((res) => {
                    console.log("res", res);
                    this.distribute = res.data.agent_distribute;
                    // this.checkObjName = res.data.agent_distribute.company.company_name;
                    this.loading = false;
                });

        },
    },
};
</script>
